export const detectTaxRegimeIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /* ----------------------------------
     * DELETE TAX REGIME (natural language)
     * ---------------------------------- */
    const deleteRegex =
        /(delete|remove|erase|drop|get rid of)\s+(the\s+)?(tax regime)?\s*(named|called|for)?\s*(.+)?/;

    const deleteMatch = cleaned.match(deleteRegex);

    if (
        deleteMatch &&
        cleaned.includes("tax") &&
        cleaned.includes("regime")
    ) {
        return {
            intent: "delete_tax_regime",
            name: deleteMatch[5]?.trim() || undefined
        };
    }

    /* ----------------------------------
     * CREATE TAX REGIME (natural language)
     * ---------------------------------- */
    const createRegex =
        /(create|add|make|setup|set up|configure|define)\s+(a\s+|new\s+)?(tax regime)?\s*(named|called|for)?\s*(.+)?/;

    const createMatch = cleaned.match(createRegex);

    if (
        createMatch &&
        cleaned.includes("tax") &&
        cleaned.includes("regime")
    ) {
        return {
            intent: "create_tax_regime",
            name: createMatch[5]?.trim() || undefined
        };
    }

    return null;
};
